module.exports = __webpack_public_path__ + "media/buy-now/bag3-d89ad49d.png";